import React, { useEffect, useState } from 'react';
import { Form, Radio, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import FormItem from 'antd/lib/form/FormItem';

import styles from './SelectClub.module.scss';
import { useUserStore } from '../../../store/useUser';
import { ClubUser } from '../../../models/clubUser';
import Button from '../../../components/Button/Button';
import { useModal, UseModalStore } from '../../../store/useModal';
import { getClub } from '../../../service/clubs';
import { Club as ClubModel } from '../../../models/club';
import Club from './Club/Club';
import { navigateToClub } from '../../../utils/club';
import { useSidebarStore } from '../../../store/useSidebar';

interface Props {
  clubs: ClubUser[]
};

const SelectClub = ({ clubs }:Props) => {
  const [form] = Form.useForm();
  const [clubSelected, setClubSelected]= useState<ClubModel[]>([]);
  const navigate = useNavigate();

  const setClub = useUserStore(state => state.setClub)
  const setClubUser = useUserStore(state => state.setClubUser)
  const profile = useUserStore(state => state.profile)
  const closeModal = useModal((state: UseModalStore) => state.closeModal);
  const setMenu = useSidebarStore(state => state.setMenu)

  useEffect(()=> {
    if (!clubs?.length) return

    let filter = []

    if(profile === 'Criador') filter = clubs.filter(club => club.isCreator === 1)
    if(profile === 'Mediador') filter = clubs.filter(club => club.isMediator === 1)

    const filterProfiles = async () => {
      const club = await Promise.all(filter.map(async (userClub) => {
        return await getClub(userClub.clubId)
      }))  

      setClubSelected(club)
    }

    filterProfiles()
  },[clubs, profile])

  const select = (values) => {
    if(!values) return;

    const club:ClubModel = JSON.parse(values.club)

    const clubUser = clubs.find(clubuser=> clubuser.clubId === club.id)

    setClubUser(clubUser)
    setClub(club)
    
    closeModal()
    
    setMenu()
    
    return navigate(navigateToClub(club?.name, club?.id), {replace: true});
  }

  return (
    <Form layout="vertical" onFinish={select} form={form} hideRequiredMark>
      <h1>Qual clube gostaria de gerenciar?</h1>
      <div style={{marginBottom: 10}}></div>
      <FormItem name="club" className={styles.clubs}>
        <Radio.Group style={{width: '100%'}} className={styles.radioGroup}>
            {
              clubSelected && clubSelected.map((club, index: number) => {
                return (
                  <Radio className={styles.radio} key={index} value={JSON.stringify(club)}>
                    <Club key={club?.id} club={club}/>
                  </Radio>
                );
              })
            }
        </Radio.Group>
      </FormItem>
      {!clubs && (
        <div className={styles.spinnerContainer}>
          <Spin className={styles.spinner} spinning={true} />
        </div>
      )}
      <Button submit>
        Feito!
      </Button>
    </Form>
  )
}

export default SelectClub;